__turbopack_context__.v({
  "advisoryContent": "AdvisoryDetail-module-scss-module__2_gRYW__advisoryContent",
  "advisoryDetailContainer": "AdvisoryDetail-module-scss-module__2_gRYW__advisoryDetailContainer",
  "advisorySummary": "AdvisoryDetail-module-scss-module__2_gRYW__advisorySummary",
  "container": "AdvisoryDetail-module-scss-module__2_gRYW__container",
  "pageWrapper": "AdvisoryDetail-module-scss-module__2_gRYW__pageWrapper",
  "socialShareButtons": "AdvisoryDetail-module-scss-module__2_gRYW__socialShareButtons",
});
